import { Button, Flex, useColorMode } from '@chakra-ui/react'
import { BsSun, BsMoonStarsFill } from 'react-icons/bs'

export default function ColorModeToggle(props) {
    // HR - used to toggle the chakraUI theme, store in localStorage
    const { colorMode, toggleColorMode } = useColorMode()
    return (
        <Flex justifyContent="center" alignItems="center">
            <Button
                aria-label="Toggle Color Mode"
                onClick={toggleColorMode}
                _focus={{ boxShadow: 'none' }}
                w="fit-content"
                {...props}
                >
                {colorMode === 'light' ? <BsMoonStarsFill /> : <BsSun />}
            </Button>
        </Flex>
    )
}